const rankData = [
  { rank: 1, title: '某顶流明星被曝隐婚三年，妻子身份曝光引全网震惊', heat: '982万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '热播剧男二号深夜密会神秘女子，工作室紧急回应', heat: '876万', tag: '热', tagColor: 'bg-secondary-500' },
  { rank: 3, title: '知名综艺录制现场突发意外，节目组发声明致歉', heat: '754万', tag: '热', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '某选秀冠军被指抄袭国外作品，粉丝集体脱粉回踩', heat: '632万', tag: '新', tagColor: 'bg-accent-500' },
  { rank: 5, title: '网红情侣分手互撕，聊天记录曝光引双方粉丝大战', heat: '518万', tag: '新', tagColor: 'bg-accent-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-fire-line text-primary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">吃瓜热榜</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">实时更新，全网最热八卦话题排行</p>

        <div className="space-y-3">
          {rankData.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group"
            >
              <span
                className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </span>
              <span
                className={`px-2.5 py-1 rounded-md text-xs font-bold text-white whitespace-nowrap ${item.tagColor}`}
              >
                {item.tag}
              </span>
              <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap w-16 text-right">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}